import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const diamondsConfig: ServicePageConfig = {
  title: 'Diamonds - Bespoke Shopping | FGA Prestige',
  description: 'Securing exceptional diamonds with expert guidance on quality and value through our bespoke shopping service.',
  slug: 'bespoke-shopping/diamonds',
  heroImage: '/Bespoke Shopping/Retail Partners/DIAMONDS/hero.png',
  serviceName: 'DIAMONDS',
  whySectionA: {
    title: 'Diamonds, Redefined: A New Way to Discover Brilliance',
    content: 'Let’s be honest – shopping for diamonds should feel exciting, personal, and a little bit magical. That’s exactly why FGA Prestige has teamed up with NYD HK Ltd. Together, we’re rethinking the experience from the ground up, giving our clients access to some of the world’s most remarkable gems.',
    image: '/Bespoke Shopping/Retail Partners/DIAMONDS/body/1.png',
    imageAlt: 'Diamond Expert Assessment'
  },
  whySectionC: {
    title: 'What\'s Happening in the Diamond World',
    content: 'There\'s a real shift underway in how people think about diamonds. Yes, rare natural stones remain timeless treasures, but lab-grown diamonds are stealing the spotlight too – offering both beauty and innovation in equal measure. Collectors and first-time buyers alike are drawn to the transparency, sustainability, and sheer artistry behind these stones. And with the diamond market evolving, smart buyers know the best gems are more than just jewellery – they\'re lasting assets with stories woven into every facet. Here\'s the important part... working with us is never just about a purchase. We offer personalised consultations, open-book transparency from origin to craftsmanship, and curated collections you won\'t find anywhere else.',
    image: '/Bespoke Shopping/Retail Partners/DIAMONDS/body/2.png',
    imageAlt: 'Diamond Expert Assessment'
  },
  whySectionB: {
    title: 'Finding Your Perfect Stone',
    benefits: [
      {
        title: '',
        description: 'Maybe you\'re dreaming of a rare, one-of-a-kind diamond with legendary provenance. Or maybe you\'re curious about a lab-grown piece that reflects your modern values without compromising on elegance. Whatever inspires you, our role is simple – listen to what you love, guide you with insight, and make the whole process effortless.'
      },
      {
        title: '',
        description: 'Because at the end of the day, finding the right diamond isn\'t just about sparkle. It\'s about discovering a piece of yourself in the brilliance.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/DIAMONDS/body/3.png',
    imageAlt: 'Premium diamond collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/DIAMONDS/CTA_Banner/banner.png'
}

const DiamondsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Diamonds - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Securing exceptional diamonds with expert guidance on quality and value through our bespoke shopping service." />
        <meta property="og:title" content="Diamonds - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Securing exceptional diamonds with expert guidance on quality and value through our bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/diamonds" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/DIAMONDS/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Diamond Collection" />
      </Helmet>
      
      <ServicePageTemplate config={diamondsConfig} />
    </>
  )
}

export default DiamondsPage